import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBellSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReceiptionBellSparkle"><Path d="M2 19.5L22 19.5" stroke="currentColor"/><Path d="M12 16.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9 3.5L15 3.5" stroke="currentColor"/><Path d="M22 16.5H2.5C2.5 10.701 6.24242 6 12 6V3.5" stroke="currentColor"/><Path d="M18.9 5.5H18.1L17.1 8.1L14.5 9.1V9.9L17.1 10.9L18.1 13.5H18.9L19.9 10.9L22.5 9.9V9.1L19.9 8.1L18.9 5.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBellSparkle;
